<template>
  <BasicPage>
    <!-- <section class="app-main"> -->
    <transition name="fade-transform" mode="out-in">
      <!-- <keep-alive> -->
      <router-view/>
      <!-- </keep-alive> -->
    </transition>
  </BasicPage>
  <!-- </section> -->
</template>

<script>
import BasicPage from "./Layout/BasicPage.vue";
export default {
  name: "safecontrol",
  data() {
    return {
      menu: false
    };
  }
  // computed: {
  //   cachedViews() {
  //     return this.$store.state.tagsView.cachedViews;
  //   },
  //   key() {
  //     return this.$route.fullPath;
  //   }
  // }
};
</script>